/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SearchResultHitCountParams {
  view_item_num: number;
  view_slug_by: string;
}

const buildSearchResultHitCountParams = (hits: number, path: string): SearchResultHitCountParams => {
  return {
    view_item_num: hits,
    view_slug_by: path,
  };
};

export const sendGAWabunkaSearchResultHitCountEvent = (hits: number, path: string) => {
  sendWabunkaGAEvent('search_result_hit_count', buildSearchResultHitCountParams(hits, path));
};
